import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LoadingContext } from '../../contexts';
import DefaultSection, {HorizontalRule} from '../../components/default_section/default_section';
import DefaultInput from '../../components/default_input/default_input';
import WarningMessage from '../../components/warning_message/warning_message';
import './document_data.scss';

class DocumentData extends React.Component {
  handleKeyDown(event) {    
    if(event.keyCode === 13 && this.props.enableSave && !this.props.isLoading) {
      this.props.onSave();
    }
  }

  isHighlighted(propertyName) {
    return this.props.highlights.includes(propertyName);
  }

  render() {
    return (
      <DefaultSection
        className="document-data"
        title="Dados do documento"
      >

        <div className="document-data__warning-container">

          <WarningMessage
            message={this.props.warningMessage}
            onClose={this.props.onCloseWarning}
            visible={this.props.showWarningMessage}
          />

        </div>

        <div className="document-data__input-container">

          <DefaultInput
            name="name"
            isHighlighted={this.isHighlighted("name")}
            label="Nome"
            type="text"
            placeholder="Nome do documento"
            maxLength="128"
            handleInputChange={this.props.handleInputChange}
            value={this.props.document.name}
            autoComplete="off"
            onKeyDown={(event) => this.handleKeyDown(event)}
            disabled={this.props.isLoading}
          />
          
          <DefaultInput
            name="description"
            isHighlighted={this.isHighlighted("description")}
            label="Descrição"
            labelMessage="Este campo será apresentado no fomulário de caso para descrever o documento"
            type="textarea"
            placeholder="Descrição do documento"
            rows="6"
            handleInputChange={this.props.handleInputChange}
            value={this.props.document.description || ''}
            disabled={this.props.isLoading}
          />

        </div>

        <HorizontalRule />

        <div className="document-data__buttons-container">

          <button
            className="document-data__save-button"
            disabled={!this.props.enableSave || this.props.isLoading}
            onClick={this.props.onSave}
          >

            Salvar

          </button>

          <Link
            className="document-data__cancel-button"
            to={this.props.onCancelPath}
            disabled={this.props.isLoading}
          >

            Cancelar

          </Link>

        </div>

      </DefaultSection>
    );
  }
};

const WrappedDocumentData = props => {
  const {isLoading} = useContext(LoadingContext);

  return (
    <DocumentData
      isLoading={isLoading}
      {...props}
    />
  );
};

export {WrappedDocumentData as DocumentData};
